export type CollectionMatch = { brand: string } | { seriesIds: string[] };

export type SeriesCollection = {
  /** URL slug, e.g. "ironman" */
  key: string;
  /** Display name shown on the tile and schedule header */
  label: string;
  /**
   * Logo served from /public/series/<file>. Drop the file in
   * apps/records/public/series/. Missing logos fall back to the label text.
   */
  logo?: string;
  /** How to resolve the collection's events on the backend */
  match: CollectionMatch;
};

export const SERIES_COLLECTIONS: SeriesCollection[] = [
  {
    key: "ironman",
    label: "Ironman",
    logo: "/series/ironman.svg",
    match: { brand: "Ironman" },
  },
  {
    key: "t100",
    label: "T100",
    logo: "/series/t100.svg",
    match: { brand: "T100" },
  },
  {
    key: "marathon-majors",
    label: "World Marathon Majors",
    logo: "/series/marathon-majors.svg",
    // Curated set — fill in the canonical event-series UUIDs for the majors.
    match: { seriesIds: [] },
  },
];

export function getCollection(key: string): SeriesCollection | undefined {
  return SERIES_COLLECTIONS.find((c) => c.key === key);
}

/** Build the /events/schedule query params for a collection. */
export function collectionScheduleParams(
  collection: SeriesCollection,
  year: number,
): { year: number; brand?: string; seriesIds?: string } {
  if ("brand" in collection.match) {
    return { year, brand: collection.match.brand };
  }
  return { year, seriesIds: collection.match.seriesIds.join(",") };
}
